import { sourceLocaleI18n } from "../../lib/i18n/catalogs";
import { SPARKLE_SOURCE_LOCALE } from "../../lib/i18n/locales";
import { createContext, useContext } from "react";
// Sparkle's own context, independent of the consumer's `I18nProvider`: the consumer picks sparkle's
// locale with `SparkleI18nProvider`. If it shared the consumer's `i18n` instance, sparkle's catalogs
// and locale changes would leak into the app (and the reverse).
//
// Without a provider (e.g. on the marketing site), sparkle renders and formats in the source locale.
//
// Passing `sourceLocaleI18n.t` unbound is safe: Lingui's `I18n` constructor sets
// `this.t = this._.bind(this)`.
export const SparkleI18nContext = createContext({
  i18n: sourceLocaleI18n,
  _: sourceLocaleI18n.t,
  formatLocale: SPARKLE_SOURCE_LOCALE
});
export function useLingui() {
  return useContext(SparkleI18nContext);
}
//# sourceMappingURL=useLingui.js.map